import React from 'react';
import { Link } from 'react-router-dom';
import { trackCaseStudyCardClick } from '../../mixpanel/events';

const CaseStudies = () => {
  const handleCaseStudyClick = (caseStudyTitle) => {
    // Track case study engagement - this is a meaningful conversion event
    trackCaseStudyCardClick(caseStudyTitle, 'case-studies');
  };

  return (
    <section id="case-studies" className="bg-apple-gray-100 py-20">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        {/* Section Header - Enhanced with social proof */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center px-4 py-2 bg-apple-gray-700 text-white text-sm font-semibold rounded-full mb-6">
            <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            Proven Results
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-apple-gray-900 mb-6">
            Real Impact, <span className="text-apple-gray-700">Measurable Results</span>
          </h2>
          <p className="text-xl text-apple-gray-600 max-w-3xl mx-auto leading-relaxed">
            See how strategic process optimization and stakeholder alignment delivered
            transformational outcomes for complex enterprise challenges.
          </p>
        </div>

        {/* Featured Case Study - Hero Layout */}
        <div className="mb-12">
          <Link
            to="/delivery-system-case-study"
            onClick={() => handleCaseStudyClick('Fixing a Broken Delivery System That Blocked Work and Killed Trust')}
            className="group block bg-white rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500 overflow-hidden border border-apple-gray-200"
          >
            {/* Case Study Header */}
            <div className="bg-apple-gray-700 px-8 py-6">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <div>
                  <div className="text-apple-gray-300 text-sm font-medium">Featured Case Study</div>
                  <div className="text-white text-lg font-semibold">Process Optimization</div>
                </div>
              </div>
            </div>

            {/* Case Study Content */}
            <div className="p-8">
              <div className="grid lg:grid-cols-3 gap-8">
                {/* Main Content */}
                <div className="lg:col-span-2">
                  <h3 className="text-2xl md:text-3xl font-bold text-apple-gray-900 mb-4 group-hover:text-apple-gray-700 transition-colors">
                    Fixing a Broken Delivery System That Blocked Work and Killed Trust
                  </h3>

                  <div className="inline-flex items-center text-apple-gray-700 font-semibold group-hover:text-apple-gray-900 transition-colors">
                    Read Complete Case Study
                    <svg className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>

      </div>
    </section>
  );
};

export default CaseStudies;